import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { gradesAPI } from '../services/api';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Modal, Button, Dropdown, Form, Row, Col, FormControl } from 'react-bootstrap';
import { PencilSquare, Trash, Search, InfoCircleFill, Plus ,CheckCircleFill, ExclamationTriangleFill, GraphUpArrow, FileEarmarkText, XCircleFill, PrinterFill } from 'react-bootstrap-icons';
import { FaQuestionCircle } from "react-icons/fa";
import GradesIcon from '../img/grades.gif';
import lineImage from '../img/line.png'; 
import transcriptImage from '../img/transcript.PNG'; 
import transcriptFooterImg from '../img/transcript_footer_img.png';
import { Bar } from 'react-chartjs-2';
import 'chart.js/auto';
import GradesGuideModal from '../Components/GradesGuideModal.jsx';
import GradeSummaryModal from '../Components/GradeSummaryModal.jsx';
import '../CSS/Grades.css';

function Grades() {
    const { user } = useSelector(state => state.auth);
    const userRole = user?.role || '';
    const [toast, setToast] = useState({
        show: false,
        message: '',
        variant: 'success'
    });
    const [gradeSummaryModal, setGradeSummaryModal] = useState({
        show: false,
        student: null,
        summaryData: null
    });
    const [showTranscriptModal, setShowTranscriptModal] = useState(false);
    const [transcriptStudent, setTranscriptStudent] = useState(null);
    const [hoveredStudent, setHoveredStudent] = useState(null);
    const [showDropdown, setShowDropdown] = useState(null);
    const [studentsData, setStudentsData] = useState([]);
    const [gradesData, setGradesData] = useState([]);
    const [activeStudent, setActiveStudent] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [editData, setEditData] = useState({
        subject: '',
        percentage: '',
        grade: ''
    });
    const [isLoadingGrades, setIsLoadingGrades] = useState(true);
    const [deleteData, setDeleteData] = useState({ id: null });
    const [searchQuery, setSearchQuery] = useState('');
    const [searchStudentsQuery, setSearchStudentsQuery] = useState('');
    const [gradesSortCriteria, setGradesSortCriteria] = useState('studentName');
    const [gradesSortOrder, setGradesSortOrder] = useState('asc');
    const [studentsSortCriteria, setStudentsSortCriteria] = useState('name');
    const [studentsSortOrder, setStudentsSortOrder] = useState('asc');
    const [showGraphModal, setShowGraphModal] = useState(false);
    const [graphData, setGraphData] = useState({ labels: [], datasets: [] });
    const [studentInputs, setStudentInputs] = useState({});
    const [subjects, setSubjects] = useState([]);
    const [isLoadingSubjects, setIsLoadingSubjects] = useState(false);
    const [originalEditData, setOriginalEditData] = useState(null);
    const [gradesClassFilter, setGradesClassFilter] = useState(null);
    const [studentsClassFilter, setStudentsClassFilter] = useState(null);
    const [currentGradesPage, setCurrentGradesPage] = useState(1);
    const [currentStudentsPage, setCurrentStudentsPage] = useState(1);
    const [gradesPerPage] = useState(75);
    const [studentsPerPage] = useState(75);
    const [totalGrades, setTotalGrades] = useState(0);
    const [totalStudents, setTotalStudents] = useState(0);
    const classOptions = [6, 7, 8, 9, 10, 11, 12];
    const [gradesClassOpen, setGradesClassOpen] = useState(false);
    const [gradesSortOpen, setGradesSortOpen] = useState(false);
    const [studentsClassOpen, setStudentsClassOpen] = useState(false);
    const [studentsSortOpen, setStudentsSortOpen] = useState(false);
    const [isLoadingStudents, setIsLoadingStudents] = useState(true);

    const showToast = (message, variant = 'success') => {
        setToast({ show: true, message, variant });
    };

    // Format pace numbers for display
    const formatPaceNumbers = (paceNumbers) => {
        if (!paceNumbers || paceNumbers.length === 0) return 'N/A';
        
        const numbers = typeof paceNumbers === 'string' 
            ? paceNumbers.split(',').map(num => parseInt(num.trim())).filter(num => !isNaN(num))
            : Array.isArray(paceNumbers)
                ? paceNumbers.map(num => parseInt(num)).filter(num => !isNaN(num))
                : [];
        
        if (numbers.length === 0) return 'N/A';
        
        numbers.sort((a, b) => a - b);
        
        const ranges = [];
        let start = numbers[0];
        let prev = numbers[0];
        
        for (let i = 1; i < numbers.length; i++) {
            if (numbers[i] === prev + 1) {
                prev = numbers[i];
            } else {
                ranges.push(start === prev ? start : `${start}–${prev}`);
                start = numbers[i];
                prev = numbers[i];
            }
        }
        
        ranges.push(start === prev ? start : `${start}–${prev}`);
        
        return ranges.join(', ');
    };

    // Validation functions
    const validateInput = (field, value) => {
        if (field === 'paceScores') {
            const numValue = parseFloat(value);
            if (isNaN(numValue) || numValue < 0 || numValue > 100) {
                return false;
            }
        } else if (field === 'subjectLevel' || field === 'paceNumbers') {
            const numValue = parseFloat(value);
            if (isNaN(numValue) || numValue < 0) {
                return false;
            }
        }
        
        const specialChars = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/;
        if (specialChars.test(value)) {
            return false;
        }
        
        return true;
    };

    // Calculate percentage from pace scores
    const calculatePercentage = (scores) => {
        const validScores = scores.filter(score => !isNaN(parseFloat(score)));
        if (validScores.length === 0) return 0;
        const sum = validScores.reduce((total, score) => total + parseFloat(score), 0);
        return (sum / validScores.length).toFixed(2);
    };

    // Calculate letter grade and GPA from percentage with class check
    const calculateGradeAndGPA = (percentage, studentClass) => {
        const percent = parseFloat(percentage);
        let letterGrade = '';
        let gpa = null;

        const classStr = String(studentClass);

        if (percent >= 97) letterGrade = 'A+';
        else if (percent >= 93) letterGrade = 'A';
        else if (percent >= 90) letterGrade = 'A-';
        else if (percent >= 87) letterGrade = 'B+';
        else if (percent >= 83) letterGrade = 'B';
        else if (percent >= 80) letterGrade = 'B-';
        else if (percent >= 77) letterGrade = 'C+';
        else if (percent >= 73) letterGrade = 'C';
        else if (percent >= 70) letterGrade = 'C-';
        else if (percent >= 67) letterGrade = 'D+';
        else if (percent >= 65) letterGrade = 'D';
        else letterGrade = 'F';

        if (classStr === '10' || classStr === '12') {
            if (percent >= 97) gpa = 4.0;
            else if (percent >= 93) gpa = 4.0;
            else if (percent >= 90) gpa = 3.7;
            else if (percent >= 87) gpa = 3.3;
            else if (percent >= 83) gpa = 3.0;
            else if (percent >= 80) gpa = 2.7;
            else if (percent >= 77) gpa = 2.3;
            else if (percent >= 73) gpa = 2.0;
            else if (percent >= 70) gpa = 1.7;
            else if (percent >= 67) gpa = 1.3;
            else if (percent >= 65) gpa = 1.0;
            else gpa = 0.0;
        }

        return { letterGrade, gpa };
    };

    useEffect(() => {
    if (toast.show) {
        const timer = setTimeout(() => {
            setToast(prev => ({ ...prev, show: false }));
        }, 3000);
        return () => clearTimeout(timer);
    }
}, [toast.show]);

    // Fetch subjects
    useEffect(() => {
        const fetchSubjects = async () => {
            setIsLoadingSubjects(true);
            try {
                const response = await gradesAPI.getSubjects();
                setSubjects(response.data);
            } catch (error) {
                console.error('Subjects fetch error:', error);
                setSubjects([]);
                showToast('Failed to load subjects. Showing limited functionality.', 'danger');
            } finally {
                setIsLoadingSubjects(false);
            }
        };

        fetchSubjects();
    }, []);

    // Fetch students and grades data with pagination
    useEffect(() => {
        const fetchStudentsData = async () => {
            setIsLoadingStudents(true);
            try {
               const response = await gradesAPI.getStudents({
            page: currentStudentsPage,
            limit: studentsPerPage,
            search: searchStudentsQuery,
            classFilter: studentsClassFilter,
            sortBy: studentsSortCriteria,
            sortOrder: studentsSortOrder
        });
                
                setStudentsData(response.data.data);
                setTotalStudents(response.data.total);
                
                const inputs = {};
                response.data.data.forEach(student => {
                    inputs[student.id] = {
                        subjectId: '',
                        subjectName: '',
                        subjectLevel: '',
                        paceNumbers: [''],
                        paceScores: [''],
                        percentage: '',
                        letterGrade: '',
                        gpa: '',
                        credits: '',
                        year: new Date().getFullYear()
                    };
                });
                setStudentInputs(inputs);
           } catch (error) {
            console.error('Error fetching students data:', error);
            showToast('Failed to fetch students data. Please try again.', 'danger');
            } finally {
                setIsLoadingStudents(false);
            }
        };

        const fetchGradesData = async () => {
            setIsLoadingGrades(true);
            try {
                const response = await gradesAPI.getGrades({
            page: currentGradesPage,
            limit: gradesPerPage,
            search: searchQuery,
            classFilter: gradesClassFilter,
            sortBy: gradesSortCriteria,
            sortOrder: gradesSortOrder
        });
                setGradesData(response.data.data);
                setTotalGrades(response.data.total);
            } catch (error) {
                console.error('Error fetching grades data:', error);
                showToast('Failed to fetch grades data. Please try again.', 'danger');
            } finally {
                setIsLoadingGrades(false);
              }
        };

        fetchStudentsData();
        fetchGradesData();
    }, [
        currentStudentsPage, 
        studentsPerPage, 
        searchStudentsQuery, 
        studentsClassFilter,
        studentsSortCriteria,
        studentsSortOrder,
        currentGradesPage,
        gradesPerPage,
        searchQuery,
        gradesClassFilter,
        gradesSortCriteria,
        gradesSortOrder
    ]);


    const fetchAllStudentGrades = async (studentId) => {
        try {
         const response = await gradesAPI.getStudentGrades(studentId);
          return response.data;
        } catch (error) {
          console.error('Error fetching all student grades:', error);
          showToast('Failed to load complete student records', 'danger');
          return [];
        }
      };

    // Handle input changes
    const handleInputChange = async (studentId, field, value, index = null) => {
        if (value === '') {
            // Allow clearing the field
        } else {
            if (!validateInput(field, value)) {
                return;
            }

            if (field === 'paceNumbers' && index !== null) {
                const currentPaceNumbers = [...studentInputs[studentId].paceNumbers];
                currentPaceNumbers[index] = value;
                
                const hasDuplicate = currentPaceNumbers.some(
                    (num, i) => num !== '' && num === value && i !== index
                );
                
                if (hasDuplicate) {
                    showToast('Duplicate Pace Numbers are not allowed', 'danger');
                    return;
                }
            }
        }

        if (field === 'subjectId') {
            const selectedSubject = subjects.find(s => s.id === parseInt(value));
            if (selectedSubject) {
                setStudentInputs(prev => ({
                    ...prev,
                    [studentId]: {
                        ...prev[studentId],
                        subjectId: selectedSubject.id,
                        subjectName: selectedSubject.name,
                        credits: selectedSubject.credits || ''
                    }
                }));
            }
        } else if (index !== null) {
            const newInputs = {
                ...studentInputs[studentId],
                [field]: studentInputs[studentId][field].map((item, i) => 
                    i === index ? value : item
                )
            };

            if (field === 'paceScores') {
                const percentage = calculatePercentage(newInputs.paceScores.filter(Boolean));
                const studentClass = studentsData.find(s => s.id === studentId)?.class || '';
                const { letterGrade, gpa } = calculateGradeAndGPA(percentage, studentClass);
                console.log('Calculated GPA:', {
                  studentId,
                  studentClass,
                  percentage,
                  gpa,
                  inputs: studentInputs[studentId]
                });
                
                setStudentInputs(prev => ({
                    ...prev,
                    [studentId]: {
                        ...newInputs,
                        percentage,
                        letterGrade,
                        gpa: (String(studentClass) === '10' || String(studentClass) === '12') ? gpa : null
                    }
                }));
                return;
            }

            setStudentInputs(prev => ({
                ...prev,
                [studentId]: newInputs
            }));
        } else {
            setStudentInputs(prev => ({
                ...prev,
                [studentId]: {
                    ...prev[studentId],
                    [field]: value
                }
            }));
        }
    };

    // Add new pace field
    const handleAddPaceField = (studentId, type) => {
        const currentValues = studentInputs[studentId][type];
        if (currentValues.includes('')) {
            showToast('Please fill all existing Pace Numbers before adding new ones', 'danger');
            return;
        }

        if (currentValues.length >= 12) {
            showToast('Maximum of 12 Pace Numbers allowed', 'danger');
            return;
        }

        setStudentInputs(prev => ({
            ...prev,
            [studentId]: {
                ...prev[studentId],
                [type]: [...prev[studentId][type], '']
            }
        }));
    };

    // Remove pace field
    const handleRemovePaceField = (studentId, type, index) => {
        setStudentInputs(prev => ({
            ...prev,
            [studentId]: {
                ...prev[studentId],
                [type]: prev[studentId][type].filter((_, i) => i !== index)
            }
        }));
    };

    // Save student grades
    const handleSaveStudentGrades = async (studentId) => {
        try {
            const student = studentsData.find(s => s.id === studentId);
            const inputs = studentInputs[studentId];
            
            if (!inputs.subjectId || inputs.paceScores.filter(Boolean).length === 0) {
                showToast('Subject and at least one Pace Score are required.', 'danger');
                return;
            }

            const selectedSubject = subjects.find(s => s.id === inputs.subjectId);
            const percentage = calculatePercentage(inputs.paceScores.filter(Boolean));
            const { letterGrade, gpa } = calculateGradeAndGPA(percentage, student.class);

             await gradesAPI.saveGrades({
            studentData: {
                id: student.id,
                studentName: student.studentName,
                class: student.class
            },
                studentSubjects: [{
                    name: selectedSubject.name,
                    subjectLevel: inputs.subjectLevel || 1,
                    paceNumbers: inputs.paceNumbers.filter(Boolean).join(','),
                    paceScores: inputs.paceScores.filter(Boolean).join(','),
                    percentage: percentage,
                    letterGrade: letterGrade,
                    gpa: (String(student.class) === '10' || String(student.class) === '12') ? gpa : null,
                    credits: inputs.credits || selectedSubject.credits || 2,
                    year: inputs.year || new Date().getFullYear()
                }]
            });

            showToast('Grades saved successfully!', 'success');
            
            // Refresh grades data
            const gradesResponse = await gradesAPI.getGrades({
            page: currentGradesPage,
            limit: gradesPerPage,
            search: searchQuery,
            classFilter: gradesClassFilter,
            sortBy: gradesSortCriteria,
            sortOrder: gradesSortOrder
        });
            setGradesData(gradesResponse.data.data);
            setTotalGrades(gradesResponse.data.total);

            // Reset the form for this student
            setStudentInputs(prev => ({
                ...prev,
                [studentId]: {
                    subjectId: '',
                    subjectName: '',
                    subjectLevel: '',
                    paceNumbers: [''],
                    paceScores: [''],
                    percentage: '',
                    letterGrade: '',
                    gpa: '',
                    credits: '',
                    year: new Date().getFullYear()
                }
            }));
        } catch (error) {
            console.error('Error saving grades:', error);
            let errorMessage = error.response?.data?.message || error.message || 'Failed to save grades. Please try again.';
            
            if (error.response?.status === 400 && error.response.data?.message?.includes('Duplicate Pace Numbers')) {
                errorMessage = error.response.data.message;
            }
            
            showToast(errorMessage, 'danger');
        }
    };

    // Handle grades sort change
    const handleGradesSortChange = (criteria, order) => {
        setGradesSortCriteria(criteria);
        setGradesSortOrder(order);
        setCurrentGradesPage(1); // Reset to first page when sorting changes
    };

    // Handle students sort change
    const handleStudentsSortChange = (criteria, order) => {
        setStudentsSortCriteria(criteria);
        setStudentsSortOrder(order);
        setCurrentStudentsPage(1); // Reset to first page when sorting changes
    };

    // Handle class filter change
    const handleGradesClassFilter = (cls) => {
        setGradesClassFilter(cls);
        setCurrentGradesPage(1); // Reset to first page when filter changes
    };

    const handleStudentsClassFilter = (cls) => {
        setStudentsClassFilter(cls);
        setCurrentStudentsPage(1); // Reset to first page when filter changes
    };

    // Handle search query changes
    const handleGradesSearch = (query) => {
        setSearchQuery(query);
        setCurrentGradesPage(1); // Reset to first page when search changes
    };

    const handleStudentsSearch = (query) => {
        setSearchStudentsQuery(query);
        setCurrentStudentsPage(1); // Reset to first page when search changes
    };

    // Handle grade click to show graph
  // Updated handleGradeClick function
const handleGradeClick = async (studentName, studentId) => {
  setActiveStudent(studentName);
  const allGrades = await fetchAllStudentGrades(studentId);
  
  if (allGrades.length > 0) {
    const labels = allGrades.map(grade => grade.subject);
    const data = allGrades.map(grade => grade.percentage);

    setGraphData({
      labels,
      datasets: [{
        label: 'Percentage',
        data,
        backgroundColor: 'rgb(100%, 64.7%, 0%)',
        borderColor: 'rgba(75, 192, 192, 1)',
        borderWidth: 1,
      }],
    });
    setShowGraphModal(true);
  } else {
    showToast('No grade data available for this student', 'warning');
  }
};

    // Pagination controls
    const GradesPagination = () => {
      const totalPages = Math.ceil(totalGrades / gradesPerPage);
      
      return (
        <div className="grd-pagination-wrapper">
          <div className="grd-pagination-info">
            {gradesData.length === 0 ? 'No records found' : 
              `${Math.min(
                currentGradesPage * gradesPerPage,
                totalGrades
              )} of ${totalGrades} records`}
          </div>
          <nav>
            <ul className="grd-pagination">
              <li className={`grd-page-item${currentGradesPage === 1 ? ' grd-disabled' : ''}`}>
                <button 
                  className="grd-page-link" 
                  onClick={() => setCurrentGradesPage(1)}
                  disabled={currentGradesPage === 1}
                >
                  First
                </button>
              </li>
              <li className={`grd-page-item${currentGradesPage === 1 ? ' grd-disabled' : ''}`}>
                <button 
                  className="grd-page-link" 
                  onClick={() => setCurrentGradesPage(currentGradesPage - 1)}
                  disabled={currentGradesPage === 1}
                >
                  Previous
                </button>
              </li>
              {[...Array(totalPages).keys()].map(number => (
                <li 
                  key={number + 1} 
                  className={`grd-page-item${currentGradesPage === number + 1 ? ' grd-active' : ''}`}
                >
                  <button 
                    className="grd-page-link" 
                    onClick={() => setCurrentGradesPage(number + 1)}
                  >
                    {number + 1}
                  </button>
                </li>
              ))}
              <li className={`grd-page-item${currentGradesPage === totalPages ? ' grd-disabled' : ''}`}>
                <button 
                  className="grd-page-link" 
                  onClick={() => setCurrentGradesPage(currentGradesPage + 1)}
                  disabled={currentGradesPage === totalPages}
                >
                  Next
                </button>
              </li>
              <li className={`grd-page-item${currentGradesPage === totalPages ? ' grd-disabled' : ''}`}>
                <button 
                  className="grd-page-link" 
                  onClick={() => setCurrentGradesPage(totalPages)}
                  disabled={currentGradesPage === totalPages}
                >
                  Last
                </button>
              </li>
            </ul>
          </nav>
        </div>
      );
    };

    const StudentsPagination = () => {
      const totalPages = Math.ceil(totalStudents / studentsPerPage);
      
      return (
        <div className="grd-pagination-wrapper">
          <div className="grd-pagination-info">
            {studentsData.length === 0 ? 'No records found' : 
              `${Math.min(
                currentStudentsPage * studentsPerPage,
                totalStudents
              )} of ${totalStudents} records`}
          </div>
          <nav>
            <ul className="grd-pagination">
              <li className={`grd-page-item${currentStudentsPage === 1 ? ' grd-disabled' : ''}`}>
                <button 
                  className="grd-page-link" 
                  onClick={() => setCurrentStudentsPage(1)}
                  disabled={currentStudentsPage === 1}
                >
                  First
                </button>
              </li>
              <li className={`grd-page-item${currentStudentsPage === 1 ? ' grd-disabled' : ''}`}>
                <button 
                  className="grd-page-link" 
                  onClick={() => setCurrentStudentsPage(currentStudentsPage - 1)}
                  disabled={currentStudentsPage === 1}
                >
                  Previous
                </button>
              </li>
              {[...Array(totalPages).keys()].map(number => (
                <li 
                  key={number + 1} 
                  className={`grd-page-item${currentStudentsPage === number + 1 ? ' grd-active' : ''}`}
                >
                  <button 
                    className="grd-page-link" 
                    onClick={() => setCurrentStudentsPage(number + 1)}
                  >
                    {number + 1}
                  </button>
                </li>
              ))}
              <li className={`grd-page-item${currentStudentsPage === totalPages ? ' grd-disabled' : ''}`}>
                <button 
                  className="grd-page-link" 
                  onClick={() => setCurrentStudentsPage(currentStudentsPage + 1)}
                  disabled={currentStudentsPage === totalPages}
                >
                  Next
                </button>
              </li>
              <li className={`grd-page-item${currentStudentsPage === totalPages ? ' grd-disabled' : ''}`}>
                <button 
                  className="grd-page-link" 
                  onClick={() => setCurrentStudentsPage(totalPages)}
                  disabled={currentStudentsPage === totalPages}
                >
                  Last
                </button>
              </li>
            </ul>
          </nav>
        </div>
      );
    };

    // Render pace data
    const renderPaceData = (data) => {
        if (!data || data.length === 0) return 'N/A';
        return (
            <div style={{ maxHeight: '150px', overflowY: 'auto' }}>
                {data.map((item, index) => (
                    <div key={index} className="mb-1">
                        {item}
                    </div>
                ))}
            </div>
        );
    };

    // Render pace inputs
    const renderPaceInputs = (studentId, type) => {
        const values = studentInputs[studentId][type] || [''];
        return (
            <div style={{ maxHeight: '150px', overflowY: 'auto' , width:'100px' }}>
                {values.map((value, index) => (
                    <div key={`${type}-${index}`} className="d-flex align-items-center mb-1">
                        <Form.Control
                            type={type === 'paceScores' ? 'number' : 'text'}
                            value={value}
                            onChange={(e) => handleInputChange(studentId, type, e.target.value, index)}
                            size="sm"
                            min={type === 'paceScores' ? 0 : undefined}
                            max={type === 'paceScores' ? 100 : undefined}
                            step={type === 'paceScores' ? 0.01 : undefined}
                            onKeyPress={(e) => {
                                if (type === 'paceScores' && e.key === '-') {
                                    e.preventDefault();
                                }
                            }}
                        />
                        {values.length > 1 && (
                            <Button 
                                variant="outline-danger" 
                                size="sm" 
                                onClick={() => handleRemovePaceField(studentId, type, index)}
                                className="ms-1"
                            >
                                ×
                            </Button>
                        )}
                    </div>
                ))}
                <Button 
                    variant="outline-primary" 
                    size="sm" 
                    onClick={() => handleAddPaceField(studentId, type)}
                    className="mt-1"
                    disabled={values.length >= 12}
                >
                    <Plus />
                </Button>
            </div>
        );
    };

    // Render student row
    const renderStudentRow = (student) => {
        return (
            <>
                {student.subjects.map((subject, subIndex) => {
                    const classStr = String(student.class);
                    const shouldShowGPA = classStr === '10' || classStr === '12';
                    const gpaValue = shouldShowGPA && subject.gpa !== null
                        ? typeof subject.gpa === 'number'
                            ? subject.gpa.toFixed(1)
                            : parseFloat(subject.gpa).toFixed(1)
                        : 'N/A';

                    return (
                        <tr 
                            key={`${student.student_id}-${student.studentName}-${subIndex}`}
                            className={[
                                        subIndex === 0 ? 'grd-first-subject-row' : 'grd-subject-row',
                                        hoveredStudent === student.student_id ? 'grd-row-hovered' : ''
                                    ].join(' ')}
                                    onMouseEnter={() => setHoveredStudent(student.student_id)}
                                    onMouseLeave={() => setHoveredStudent(null)}
                        >
                            {subIndex === 0 && (
                                <>
                                  <td
                                            rowSpan={student.subjects.length}
                                            onMouseEnter={() => setShowDropdown(student.student_id)}
                                            onMouseLeave={() => setShowDropdown(null)}
                                            style={{ position: 'relative', cursor: 'default' }}
                                        >
                                        <div className="d-flex align-items-center">
                                            {student.studentName}
                                        </div>
                                        
                                        {showDropdown === student.student_id && (userRole === 'admin') && (
                                            <div style={{ position: 'absolute', left: 0, zIndex: 100 }}
                                            onClick={(e) => e.stopPropagation()}>
                                                <StudentNameDropdown 
                                                    studentId={student.student_id}
                                                    studentName={student.studentName}
                                                    studentClass={student.class}
                                                    onClose={() => setShowDropdown(null)}
                                                />
                                            </div>
                                        )}
                                    </td>
                                    <td rowSpan={student.subjects.length}>{student.class}</td>
                                </>
                            )}
                            <td>{subject.subject}</td>
                            <td>{subject.subjectLevel}</td>
                            <td>{renderPaceData(subject.paceNumbers)}</td>
                            <td>{renderPaceData(subject.paceScores)}</td>
                            <td>{subject.percentage}</td>
                            <td>{subject.letterGrade}</td>
                            <td>{gpaValue}</td>
                            <td>{subject.credits}</td>
                            {subIndex === 0 && (
                                <td rowSpan={student.subjects.length}>
                                    {student.subjects.length > 0 ? student.subjects[0].year : ''}
                                </td>
                            )}
                            {(userRole === 'admin') && (
                                <>
                                    <td>
                                        <div className="d-flex grd-action-btn">
                                            <span 
                                                className="icon text-primary cursor-pointer" 
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleEditClick({
                                                        ...subject,
                                                        subject: subject.subject,
                                                        studentName: student.studentName,
                                                        class: student.class,
                                                        id: subject.id
                                                    });
                                                }}
                                            ><button className='grd-action-edit'>
                                                <PencilSquare />
                                                </button>
                                            </span>
                                            <span 
                                                className="icon text-danger cursor-pointer ms-2" 
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleDeleteClick(subject.id);
                                                }}
                                            >
                                                <button className='grd-action-delete'>
                                                <Trash />
                                                </button>
                                            </span>
                                        </div>
                                    </td>
                                </>
                            )}
                        </tr>
                    );
                })}
            </>
        );
    };

    // Render subject dropdown
    const renderSubjectDropdown = (studentId) => (
        <Form.Select
            value={studentInputs[studentId]?.subjectId || ''}
            onChange={(e) => handleInputChange(studentId, 'subjectId', e.target.value)}
            disabled={isLoadingSubjects}
        >
            <option value="">{isLoadingSubjects ? 'Loading subjects...' : 'Select'}</option>
            {subjects.map(subject => (
                <option key={subject.id} value={subject.id}>
                    {subject.name} (Credits: {subject.credits})
                </option>
            ))}
        </Form.Select>
    );

    // When setting edit data:
    const handleEditClick = (data) => {
        const normalizedData = {
            ...data,
            gpa: data.gpa !== null && data.gpa !== undefined 
                ? typeof data.gpa === 'number' 
                    ? data.gpa 
                    : parseFloat(data.gpa)
                : null,
            percentage: data.percentage ? parseFloat(data.percentage) : null,
            subjectLevel: data.subjectLevel ? parseInt(data.subjectLevel) : 1
        };
        
        setEditData(normalizedData);
        setOriginalEditData(normalizedData);
        setShowEditModal(true);
    };

    // Handle delete click
    const handleDeleteClick = (id) => {
        setDeleteData({ id });
        setShowDeleteModal(true);
    };

    // Handle edit change
    const handleEditChange = (e) => {
        const { name, value } = e.target;
        
        const updatedData = { ...editData };
    
        switch (name) {
            case 'paceNumbers':
                const numbersArray = value.split(',').map(num => num.trim()).filter(num => num !== '');
                const uniqueNumbers = [...new Set(numbersArray)];
                if (uniqueNumbers.length !== numbersArray.length) {
                    showToast('Duplicate Pace Numbers in your input. Please remove duplicates.', 'danger');
                    return;
                }
                
                updatedData[name] = value;
                break;
    
            case 'paceScores':
                const scoresArray = value.split(',').map(score => score.trim()).filter(score => score !== '');
                const invalidScores = scoresArray.filter(score => {
                    const num = parseFloat(score);
                    return isNaN(num) || num < 0 || num > 100;
                });
                
                if (invalidScores.length > 0) {
                    showToast(`Invalid scores: ${invalidScores.join(', ')}. Must be between 0-100.`, 'danger');
                    return;
                }
                
                updatedData[name] = value;
                
                const percentage = calculatePercentage(scoresArray);
                const { letterGrade, gpa } = calculateGradeAndGPA(percentage, editData.class);
                
                updatedData.percentage = percentage;
                updatedData.letterGrade = letterGrade;
                updatedData.gpa = (String(editData.class) === '10' || String(editData.class) === '12') ? gpa : null;
                break;
    
            case 'subjectLevel':
                const level = parseInt(value);
                if (isNaN(level)) {
                    updatedData[name] = '';
                } else {
                    updatedData[name] = Math.max(1, level);
                }
                break;
    
            case 'year':
                const year = parseInt(value);
                const currentYear = new Date().getFullYear();
                if (!isNaN(year)) {
                    updatedData[name] = Math.min(Math.max(2000, year), currentYear + 5);
                } else {
                    updatedData[name] = '';
                }
                break;
    
            default:
                updatedData[name] = value;
        }
    
        setEditData(updatedData);
    };

    // Save edit changes
    const saveEditChanges = async () => {
        try {
            const dataToSend = {};
            
            if (editData.subjectLevel !== originalEditData.subjectLevel) {
                dataToSend.subjectLevel = editData.subjectLevel;
            }
            
            if (editData.paceNumbers !== originalEditData.paceNumbers) {
                const normalizedPaceNumbers = typeof editData.paceNumbers === 'string' 
                    ? editData.paceNumbers 
                    : Array.isArray(editData.paceNumbers)
                        ? editData.paceNumbers.join(',')
                        : String(editData.paceNumbers);
                dataToSend.paceNumbers = normalizedPaceNumbers;
            }
            
            if (editData.paceScores !== originalEditData.paceScores) {
                const normalizedPaceScores = typeof editData.paceScores === 'string' 
                    ? editData.paceScores 
                    : Array.isArray(editData.paceScores)
                        ? editData.paceScores.join(',')
                        : String(editData.paceScores);
                dataToSend.paceScores = normalizedPaceScores;
            }
            
            if (editData.year !== originalEditData.year) {
                dataToSend.year = editData.year;
            }
    
            if (Object.keys(dataToSend).length === 0) {
                showToast('No changes were made', 'info');
                return;
            }
    
            const response = await gradesAPI.updateGrade(editData.id, dataToSend);
    
             const updatedGradesResponse = await gradesAPI.getGrades({
            page: currentGradesPage,
            limit: gradesPerPage,
            search: searchQuery,
            classFilter: gradesClassFilter,
            sortBy: gradesSortCriteria,
            sortOrder: gradesSortOrder
        });
            
            const normalizedGrades = updatedGradesResponse.data.data.map(student => ({
                ...student,
                subjects: student.subjects.map(subject => ({
                    ...subject,
                    gpa: subject.gpa !== null ? Number(subject.gpa) : null,
                    percentage: subject.percentage ? parseFloat(subject.percentage) : 0,
                    subjectLevel: subject.subjectLevel ? parseInt(subject.subjectLevel) : 1
                }))
            }));
    
            setGradesData(normalizedGrades);
            setTotalGrades(updatedGradesResponse.data.total);
            
            setShowEditModal(false);
            showToast(response.data?.message || 'Grade updated successfully', 'success');
        } catch (error) {
            console.error('Error updating grade:', error);
            
            let errorMessage = 'Failed to update grade. Please try again.';
            let errorDetails = '';
            
            if (error.response) {
                if (error.response.status === 400) {
                    if (error.response.data.message?.includes('Duplicate Pace Numbers')) {
                        errorMessage = 'Duplicate Pace Numbers Error';
                        errorDetails = error.response.data.message;
                    } else if (error.response.data.errors) {
                        errorMessage = 'Validation Error';
                        errorDetails = Object.values(error.response.data.errors).join(', ');
                    }
                }
                else if (error.response.status === 404) {
                    errorMessage = 'Grade not found';
                }
            } else if (error.request) {
                errorMessage = 'No response from server. Please check your connection.';
            } else {
                errorDetails = error.message;
            }
    
            showToast(`${errorMessage}${errorDetails ? `: ${errorDetails}` : ''}`, 'danger');
        }
    };

    // Confirm delete
    const confirmDelete = async () => {
        try {
            await gradesAPI.deleteGrade(deleteData.id);
            
            const updatedGradesResponse = await gradesAPI.getGrades({
            page: currentGradesPage,
            limit: gradesPerPage,
            search: searchQuery,
            classFilter: gradesClassFilter,
            sortBy: gradesSortCriteria,
            sortOrder: gradesSortOrder
        });
            
            setGradesData(updatedGradesResponse.data.data);
            setTotalGrades(updatedGradesResponse.data.total);
            
            setShowDeleteModal(false);
            showToast('Grade deleted successfully.', 'success');
        } catch (error) {
            console.error('Error deleting grade:', error);
            showToast('Failed to delete grade. Please try again.', 'danger');
        }
    };

    // StudentNameDropdown component
    const StudentNameDropdown = ({ studentId, studentName, studentClass, onClose }) => {
        const handleOptionClick = async (option) => {
            try {
                const allGrades = await fetchAllStudentGrades(studentId);
                
                if (!allGrades || allGrades.length === 0) {
                    onClose();
                    showToast('No records found for this student', 'warning');
                    return;
                }
    
                const studentWithAllGrades = {
                    student_id: studentId,
                    studentName,
                    class: studentClass,
                    subjects: allGrades.map(grade => ({
                        id: grade.id,
                        subject: grade.subject,
                        subjectLevel: grade.subjectLevel,
                        paceNumbers: grade.paceNumbers ? grade.paceNumbers.split(',').filter(Boolean) : [],
                        paceScores: grade.paceScores ? grade.paceScores.split(',').filter(Boolean) : [],
                        percentage: grade.percentage,
                        letterGrade: grade.letterGrade,
                        gpa: grade.gpa,
                        credits: grade.credits,
                        year: grade.year
                    }))
                };
    
                switch(option) {
                    case 'Generate Transcript':
                        setTranscriptStudent(studentWithAllGrades);
                        setShowTranscriptModal(true);
                        break;
                    case 'View Grade Summary':
                        const totalCredits = studentWithAllGrades.subjects.reduce((sum, subject) => {
                            return sum + (parseInt(subject.credits) || 0);
                        }, 0);
                        
                        let academicGPA = null;
                        if (studentClass === 10 || studentClass === 12) {
                            const gpaSubjects = studentWithAllGrades.subjects.filter(subject => subject.gpa !== null);
                            if (gpaSubjects.length > 0) {
                                const totalGPA = gpaSubjects.reduce((sum, subject) => sum + parseFloat(subject.gpa), 0);
                                academicGPA = (totalGPA / gpaSubjects.length).toFixed(2);
                            }
                        }
                        
                        setGradeSummaryModal({
                            show: true,
                            student: studentWithAllGrades,
                            summaryData: {
                                totalCredits,
                                academicGPA
                            }
                        });
                        break;
                    case 'View on Graph':
                        handleGradeClick(studentName, studentId);
                        break;
                    default:
                        break;
                }
            } catch (error) {
                console.error('Error in StudentNameDropdown:', error);
                showToast('Failed to load student data', 'danger');
            } finally {
                onClose();
            }
        };
    
        const isClass10Or12 = studentClass === 10 || studentClass === 12;
    
        return (
           <div className="grd-records-dropdown">
        <div className="grd-records-dropdown__menu">

            {isClass10Or12 && (
            <button
                className="grd-records-dropdown__item grd-records-dropdown__item--primary"
                onClick={() => handleOptionClick('Generate Transcript')}
            >
                <i className="bi bi-file-earmark-pdf-fill" />
                Generate Transcript
            </button>
            )}

            <button
            className="grd-records-dropdown__item grd-records-dropdown__item--success"
            onClick={() => handleOptionClick('View Grade Summary')}
            >
            <i className="bi bi-stack" />
            View Grade Summary
            </button>

            <button
            className="grd-records-dropdown__item grd-records-dropdown__item--warning"
            onClick={() => handleOptionClick('View on Graph')}
            >
            <i className="bi bi-file-bar-graph-fill" />
            View on Graph
            </button>

        </div>
        </div>
                );
    };

   const GraphModal = ({ show, onHide, studentName, graphData }) => {
    if (!graphData || graphData.labels.length === 0) {
        return (
            <Modal show={show} onHide={onHide} size="lg" centered>
                <div className="grd-modal-content">
                    <Modal.Header closeButton className="grd-graph-modal-header">
                        <Modal.Title className="grd-modal-title">
                            <i className="bi bi-bar-chart-fill grd-modal-title-icon"></i>
                            {studentName}'s Academic Report
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="grd-graph-modal-body">
                        <div className="grd-graph-empty-state">
                            <i className="bi bi-inbox grd-graph-empty-icon"></i>
                            <p className="grd-graph-empty-text">No grade data available to display</p>
                        </div>
                    </Modal.Body>
                    <Modal.Footer className="grd-graph-modal-footer">
                        <button className="grd-btn grd-btn-secondary" onClick={onHide}>Close</button>
                    </Modal.Footer>
                </div>
            </Modal>
        );
    }

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: { position: 'top' },
            tooltip: {
                callbacks: {
                    label: (context) => {
                        const label = context.dataset.label || '';
                        const value = context.raw;
                        const student = gradesData.find(s => s.studentName === studentName);
                        if (student) {
                            const subject = student.subjects.find(sub => sub.subject === context.label);
                            if (subject) {
                                return [
                                    `${label}: ${value}%`,
                                    `Letter Grade: ${subject.letterGrade}`,
                                    subject.gpa !== null && !isNaN(parseFloat(subject.gpa))
                                        ? `GPA: ${parseFloat(subject.gpa).toFixed(1)}`
                                        : '',
                                    `Credits: ${subject.credits}`
                                ].filter(Boolean);
                            }
                        }
                        return `${label}: ${value}%`;
                    }
                }
            }
        },
        scales: {
            y: {
                beginAtZero: true,
                max: 100,
                title: { display: true, text: 'Percentage (%)' }
            }
        }
    };

    const enhancedGraphData = {
        ...graphData,
        datasets: graphData.datasets.map(dataset => ({
            ...dataset,
            backgroundColor: [
                'rgba(0, 242, 254, 0.75)',
                'rgba(79, 172, 254, 0.75)',
                'rgba(52, 152, 219, 0.75)',
                'rgba(0, 242, 254, 0.55)',
                'rgba(79, 172, 254, 0.55)',
                'rgba(165, 180, 252, 0.75)',
            ],
            borderColor: [
                'rgba(0, 242, 254, 1)',
                'rgba(79, 172, 254, 1)',
                'rgba(52, 152, 219, 1)',
                'rgba(0, 242, 254, 0.85)',
                'rgba(79, 172, 254, 0.85)',
                'rgba(165, 180, 252, 1)',
            ],
            borderWidth: 2,
            borderRadius: 6,
            hoverBackgroundColor: 'rgba(0, 242, 254, 0.9)',
            hoverBorderColor: '#00f2fe',
        }))
    };

    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            <div className="grd-modal-content">
                <Modal.Header closeButton className="grd-graph-modal-header">
                   <Modal.Title className="grd-modal-title grd-modal-title--graph">
                    <i className="bi bi-bar-chart-fill grd-modal-title-icon"></i>
                    {studentName}'s Academic Report
                </Modal.Title>
                </Modal.Header>

                <Modal.Body className="grd-graph-modal-body">
                    <div className="grd-chart-container">
                        <Bar data={enhancedGraphData} options={options} />
                    </div>

                    <div className="grd-graph-subject-section">
                        <h3 className="grd-graph-subject-title">Subject Details</h3>
                        <ul className="grd-graph-subject-list">
                            {graphData.labels.map((label, index) => (
                                <li key={index} className="grd-graph-subject-item">
                                    <span className="grd-graph-subject-name">{label}</span>
                                    <span className="grd-badge-primary">
                                        {graphData.datasets[0].data[index]}%
                                    </span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </Modal.Body>

                <Modal.Footer className="grd-graph-modal-footer">
                    <button className="grd-btn grd-btn-secondary" onClick={onHide}>
                        <i className="bi bi-x-circle"></i> Close
                    </button>
                </Modal.Footer>
            </div>
        </Modal>
    );
};

    // TranscriptModal component
    const TranscriptModal = ({ show, onHide, student, gradesData }) => {
        const [completionMonth, setCompletionMonth] = useState('November');
    
        if (!student) return null;
    
        const totalCredits = student.subjects.reduce((sum, subject) => {
            return sum + (parseInt(subject.credits) || 0);
        }, 0);
    
        let academicGPA = null;
        if (student.class === 10 || student.class === 12) {
            const gpaSubjects = student.subjects.filter(subject => subject.gpa !== null);
            if (gpaSubjects.length > 0) {
                const totalGPA = gpaSubjects.reduce((sum, subject) => sum + parseFloat(subject.gpa), 0);
                academicGPA = (totalGPA / gpaSubjects.length).toFixed(1);
            }
        }
    
        const handlePrint = () => {
            const printWindow = window.open('', '_blank');
    
            const htmlContent = `
                <!DOCTYPE html>
                <html>
                    <head>
                        <title>Transcript for ${student.studentName}</title>
                        <style>
                            @page {
                                size: A4;
                                margin: 0;
                            }
                            body {
                                font-family: Arial, sans-serif;
                                padding: 30px;
                                color: #333;
                                position: relative;
                                min-height: 297mm;
                                box-sizing: border-box;
                                overflow: hidden;
                            }
                            * {
                                font-size: 10px;
                            }
                            .header {
                                text-align: left;
                                margin-bottom: 15px;
                            }
                            .student-name {
                                font-size: 12px;
                                font-weight: bold;
                                margin-bottom: 3px;
                            }
                            .academy-name {
                                font-size: 14px;
                                margin-bottom: 3px;
                            }
                            .certificate-title {
                                font-size: 18px;
                                font-weight: bold;
                                margin: 15px 0;
                                text-align: center;
                            }
                            table {
                                width: 100%;
                                border-collapse: collapse;
                                margin: 10px 0;
                                page-break-inside: avoid;
                                font-size: 9px;
                            }
                            th, td {
                                border: 1px solid #ddd;
                                padding: 3px;
                                text-align: left;
                            }
                            th {
                                background-color: #f2f2f2;
                                padding: 4px;
                            }
                            .footer {
                                margin-top: 15px;
                                font-size: 9px;
                                position: absolute;
                                bottom: 60px;
                                left: 30px;
                                right: 30px;
                            }
                            .signature {
                                margin-top: 15px;
                            }
                            .pace-numbers {
                                white-space: nowrap;
                            }
                            @media print {
                                body {
                                    padding: 20px;
                                    -webkit-print-color-adjust: exact;
                                    print-color-adjust: exact;
                                }
                                .wave {
                                    display: block;
                                }
                            }
                        </style>
                    </head>
                    <body>
                        <div class="header" style="display: flex; justify-content: space-between; align-items: flex-start; width: 100%;">
                            <div style="flex: 1; min-width: 200px;">
                                <div class="student-name">${student.studentName}</div>
                                <div class="academy-name">Eastern Pacific Academy</div>
                                <div>Papua New Guinea</div>
                            </div>
    
                            <div style="text-align: right;">
                                <div class="transcript"><img src="${transcriptImage}" alt="Footer Image" style="width: 100%; max-height: 80px;" /></div>
                            </div>
                        </div>
    
                        <div class="certificate-title">Year ${student.class} Certificate</div>
                  
                        <div class="mb-2" style="text-align: center; font-size: 10px;">
                            <div>Academic Endorsed</div>
                            <div>Completed in ${completionMonth}, ${new Date().getFullYear()}</div>
                        </div>
                  
                        <table>
                            <thead>
                                <tr>
                                    <th style="width: 5%;">Code</th>
                                    <th style="width: 20%;">Subject</th>
                                    <th style="width: 8%;">Subject Lvl</th>
                                    <th style="width: 15%;">PACE Numbers</th>
                                    <th style="width: 8%;">Percentage</th>
                                    <th style="width: 8%;">Letter Grade</th>
                                    <th style="width: 8%;">GPA</th>
                                    <th style="width: 8%;">Credits</th>
                                </tr>
                            </thead>
                            <tbody>
                                ${student.subjects.map((subject, index) => (
                                    `<tr key=${index}>
                                        <td>ACE</td>
                                        <td>${subject.subject}</td>
                                        <td>${subject.subjectLevel}</td>
                                        <td class="pace-numbers">${formatPaceNumbers(subject.paceNumbers)}</td>
                                        <td>${subject.percentage}%</td>
                                        <td>${subject.letterGrade}</td>
                                        <td>${subject.gpa !== null ? parseFloat(subject.gpa).toFixed(1) : 'N/A'}</td>
                                        <td>${subject.credits}</td>
                                    </tr>`
                                )).join('')}
                            </tbody>
                        </table>
                  
                        <div class="mb-2" style="font-size: 9px;">
                            <div>Each credit is equivalent to one semester's workload.</div>
                            <div style="text-align: right;"><strong>Total Credits: ${totalCredits}</strong></div>
                        </div>
    
                        ${academicGPA ? `
                            <div class="mb-2" style="font-size: 9px;">
                                <div>This GPA is based on a 4.0 scale as per international standards, and is calculated for <br> A.C.E./SCEE subjects only.</div>
                                <div style="text-align: right;"><strong>Academic GPA: ${academicGPA}</strong></div>
                            </div>
                        ` : ''}
    
                        <div class="footer" style="display: flex; justify-content: space-between; align-items: flex-start; width: 100%; gap: 20px; flex-wrap: wrap;">
                            <div style="flex: 1; min-width: 250px; margin-top:15px; margin-left: 15px; font-size: 9px;">
                                <div>ACE = A.C.E. School of Tomorrow® Course.</div>
                                <div>LSC = Local School Course - A course of study developed by the local school as indicated above.</div>
                                <div>OSC = Other School Course - A course of study developed by a body other than A.C.E. or the local school as indicated above.</div>
                                <div>RPL = Recognized Prior Learning - A course completed towards graduation at a previous educational institute.</div>
                                <div style="margin-top: 10px;">
                                    <div>Date of Issue: ${new Date().toLocaleDateString()}</div>
                                    <div>Certificate ID Number: PG${new Date().getFullYear().toString().slice(2)}${Math.floor(100000 + Math.random() * 900000)}-${Math.floor(100 + Math.random() * 900)}</div>
                                </div>
                            </div>
    
                            <div style="flex: 1; min-width: 250px; font-size: 9px;">
                                <div class="signature" style="margin-bottom: 15px;">
                                    <div style="margin-bottom: 30px;">This transcript is issued without alteration and erasure.</div>
                                    <div class="signature-name">Slabbert Pretorius</div>
                                    <div>Managing Director</div>
                                    <div>Accelerate Educational Ministries</div>
                                    <div>PO Box 3102, Caboolure B.C., QLD, 4510</div>
                                    <div>Australia</div>
                                </div>
                            </div>
    
                            <div style="width: 100%;">
                                <img src="${lineImage}" alt="Footer Image" style="width: 100%; max-height: 80px;" />
                            </div>
                            <div style="width: 100%;">
                                <img 
                                    src="${transcriptFooterImg}" 
                                    alt="Footer Image" 
                                    style="max-height: 80px; display: block; margin-left: auto; margin-right:20px;" 
                                />
                            </div>
                        </div>
                    </body>
                </html>
            `;
    
            printWindow.document.open();
            printWindow.document.write(htmlContent);
            printWindow.document.close();
    
            printWindow.onload = function () {
                setTimeout(() => {
                    printWindow.print();
                    printWindow.close();
                }, 500);
            };
        };
    
     return (
    <Modal show={show} onHide={onHide} size="xl" centered>
        <Modal.Header closeButton className="grd-modal-header">
            <Modal.Title className="grd-modal-title">
                <FileEarmarkText className="grd-modal-title-icon" />
                Generate Transcript — {student.studentName}
            </Modal.Title>
        </Modal.Header>
        <Modal.Body className="grd-modal-body">
            <div className="grd-transcript-preview">
                <div className="grd-transcript-preview-row">
                    <span className="grd-transcript-preview-label">Student</span>
                    <span className="grd-transcript-preview-value">{student.studentName}</span>
                </div>
                <div className="grd-transcript-preview-row">
                    <span className="grd-transcript-preview-label">Class</span>
                    <span className="grd-transcript-preview-value">{student.class}</span>
                </div>
                <div className="grd-transcript-preview-row">
                    <span className="grd-transcript-preview-label">Total Credits</span>
                    <span className="grd-transcript-preview-value">{totalCredits}</span>
                </div>
                {academicGPA && (
                    <div className="grd-transcript-preview-row">
                        <span className="grd-transcript-preview-label">Academic GPA</span>
                        <span className="grd-transcript-preview-value">{academicGPA}</span>
                    </div>
                )}
            </div>

            <div className="grd-modal-field-group">
                <label className="grd-modal-label">Completion Month</label>
                <select
                    className="grd-modal-select"
                    value={completionMonth}
                    onChange={(e) => setCompletionMonth(e.target.value)}
                >
                    {[
                        'January', 'February', 'March', 'April', 'May', 'June',
                        'July', 'August', 'September', 'October', 'November', 'December'
                    ].map(month => (
                        <option key={month} value={month}>{month}</option>
                    ))}
                </select>
            </div>

            <div className="grd-modal-hint">
                <InfoCircleFill className="grd-modal-hint-icon" />
                Click <strong>"Print Transcript"</strong> to generate and print the document.
            </div>
        </Modal.Body>
        <Modal.Footer className="grd-modal-footer">
            <button className="grd-btn grd-btn-danger" onClick={onHide}>
                <XCircleFill className="grd-modal-btn-icon" /> Close
            </button>
            <button className="grd-btn grd-btn-primary" onClick={handlePrint}>
                <PrinterFill className="grd-modal-btn-icon" /> Print Transcript
            </button>
        </Modal.Footer>
    </Modal>
);
    };

    return (
        <>
            <div className='grd-page container-fluid'>

                <div className='row'>
                    <div className='dashboard d-flex flex-wrap'>
                        <div className="dashboard-Container col">
                            <div className="grd-inner-container container-fluid">
                                <div className='row my-4'>
                                    {userRole === 'staff' && (
                                        <div className="grd-staff-alert">
                                            <i className="bi bi-info-circle"></i> You have view-only access as a staff member.
                                        </div>
                                    )}
                                    <div className='col-12'>
                                        <h3>Academic Reports <img className='grd-animated-icon' src={GradesIcon} alt='Grades icon' /></h3>
                                    </div>
                                </div>

                                <div className="grd-search-wrapper">
                                    <Search className="grd-search-icon" />
                                    <input 
                                        type="text" 
                                        className="grd-search-input" 
                                        placeholder="Search academic reports..." 
                                        value={searchQuery} 
                                        onChange={(e) => handleGradesSearch(e.target.value)}
                                    />
                                </div>

                              <div className="grd-toolbar">
                                <div className="grd-dropdown">
                                    <button
                                        className="grd-dropdown-toggle grd-dropdown-toggle--success"
                                        onClick={() => { setGradesClassOpen(o => !o); setGradesSortOpen(false); }}
                                    >
                                        {gradesClassFilter ? `Class: ${gradesClassFilter}` : 'Filter by Class'}
                                        <span className="grd-dropdown-arrow">{gradesClassOpen ? '▲' : '▼'}</span>
                                    </button>
                                    {gradesClassOpen && (
                                        <div className="grd-dropdown-menu">
                                            <button className="grd-dropdown-item" onClick={() => { handleGradesClassFilter(null); setGradesClassOpen(false); }}>All Classes</button>
                                            {classOptions.map(cls => (
                                                <button key={`grades-class-${cls}`} className="grd-dropdown-item" onClick={() => { handleGradesClassFilter(cls); setGradesClassOpen(false); }}>
                                                    Class {cls}
                                                </button>
                                            ))}
                                        </div>
                                    )}
                                </div>

                                <div className="grd-dropdown">
                                    <button
                                        className="grd-dropdown-toggle grd-dropdown-toggle--warning"
                                        onClick={() => { setGradesSortOpen(o => !o); setGradesClassOpen(false); }}
                                    >
                                        Sort: {gradesSortCriteria} ({gradesSortOrder})
                                        <span className="grd-dropdown-arrow">{gradesSortOpen ? '▲' : '▼'}</span>
                                    </button>
                                    {gradesSortOpen && (
                                        <div className="grd-dropdown-menu">
                                            <button className="grd-dropdown-item" onClick={() => { handleGradesSortChange('studentName', 'asc'); setGradesSortOpen(false); }}>Student Name - Ascending</button>
                                            <button className="grd-dropdown-item" onClick={() => { handleGradesSortChange('studentName', 'desc'); setGradesSortOpen(false); }}>Student Name - Descending</button>
                                            <button className="grd-dropdown-item" onClick={() => { handleGradesSortChange('class', 'asc'); setGradesSortOpen(false); }}>Class - Ascending</button>
                                            <button className="grd-dropdown-item" onClick={() => { handleGradesSortChange('class', 'desc'); setGradesSortOpen(false); }}>Class - Descending</button>
                                        </div>
                                    )}
                                </div>
                            </div>

                                <section className="grd-table-section mb-5">
                                    <h4 className='text-center mb-2 grd-section-label'>Recorded Academic Results</h4>
                                    <div className="grd-table-container">
                                        <div className="grd-table-wrapper">
                                            <table className="grd-table">
                                                <thead>
                                                    <tr className="grd-table-header">
                                                        <th>Student Name</th>
                                                        <th>Class</th>
                                                        <th>Subject Name</th>
                                                        <th>Subject Level</th>
                                                        <th>Pace Numbers</th>
                                                        <th>Pace Scores</th>
                                                        <th>Percentage</th>
                                                        <th>Letter Grade</th>
                                                        <th>GPA</th>
                                                        <th>Credits</th>
                                                        <th>Year</th>
                                                        {(userRole === 'admin') && (
                                                            <th>Actions</th>
                                                        )}
                                                    </tr>
                                                </thead>
                                                <tbody className="grd-table-body">
                                                    {isLoadingGrades ? (
                                                    <tr>
                                                        <td colSpan="12" className="grd-loading-state">
                                                            <div className="grd-loader-wrap">
                                                                <div className="grd-loader-ring"></div>
                                                                <span className="grd-loader-text">Loading Academic Records</span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    ) : gradesData.length > 0 ? (
                                                        gradesData.map(renderStudentRow)
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="12" className="grd-empty-state">
                                                                <InfoCircleFill className="grd-empty-icon"/> No results found
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <GradesPagination />

                                    {(userRole === 'admin') && (
                                        <>
                                            <div className="grd-search-wrapper grd-search-wrapper--mt">
                                                <Search className="grd-search-icon" />
                                                <input 
                                                    type="text" 
                                                    className="grd-search-input" 
                                                    placeholder="Search Students..." 
                                                    value={searchStudentsQuery}
                                                    onChange={(e) => handleStudentsSearch(e.target.value)}
                                                />
                                            </div>

                                           <div className="grd-toolbar grd-toolbar--end">
                                                <div className="grd-dropdown">
                                                    <button
                                                        className="grd-dropdown-toggle grd-dropdown-toggle--success"
                                                        onClick={() => { setStudentsClassOpen(o => !o); setStudentsSortOpen(false); }}
                                                    >
                                                        {studentsClassFilter ? `Class: ${studentsClassFilter}` : 'Filter by Class'}
                                                        <span className="grd-dropdown-arrow">{studentsClassOpen ? '▲' : '▼'}</span>
                                                    </button>
                                                    {studentsClassOpen && (
                                                        <div className="grd-dropdown-menu">
                                                            <button className="grd-dropdown-item" onClick={() => { handleStudentsClassFilter(null); setStudentsClassOpen(false); }}>All Classes</button>
                                                            {classOptions.map(cls => (
                                                                <button key={`students-class-${cls}`} className="grd-dropdown-item" onClick={() => { handleStudentsClassFilter(cls); setStudentsClassOpen(false); }}>
                                                                    Class {cls}
                                                                </button>
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>

                                                <div className="grd-dropdown">
                                                    <button
                                                        className="grd-dropdown-toggle grd-dropdown-toggle--warning"
                                                        onClick={() => { setStudentsSortOpen(o => !o); setStudentsClassOpen(false); }}
                                                    >
                                                        Sort: {studentsSortCriteria} ({studentsSortOrder})
                                                        <span className="grd-dropdown-arrow">{studentsSortOpen ? '▲' : '▼'}</span>
                                                    </button>
                                                    {studentsSortOpen && (
                                                        <div className="grd-dropdown-menu">
                                                            <button className="grd-dropdown-item" onClick={() => { handleStudentsSortChange('studentName', 'asc'); setStudentsSortOpen(false); }}>Student Name - Ascending</button>
                                                            <button className="grd-dropdown-item" onClick={() => { handleStudentsSortChange('studentName', 'desc'); setStudentsSortOpen(false); }}>Student Name - Descending</button>
                                                            <button className="grd-dropdown-item" onClick={() => { handleStudentsSortChange('class', 'asc'); setStudentsSortOpen(false); }}>Class - Ascending</button>
                                                            <button className="grd-dropdown-item" onClick={() => { handleStudentsSortChange('class', 'desc'); setStudentsSortOpen(false); }}>Class - Descending</button>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            <h4 className='text-center grd-section-label'>New Academic Record Entries</h4>
                                            <div className="grd-table-container">
                                                <div className="grd-table-wrapper">
                                                    <table className="grd-table">
                                                        <thead>
                                                            <tr className="grd-table-header">
                                                                <th>Student Name</th>
                                                                <th>Class</th>
                                                                <th>Subject Name</th>
                                                                <th>Subject Level</th>
                                                                <th>Pace Numbers</th>
                                                                <th>Pace Scores</th>
                                                                <th>Percentage</th>
                                                                <th>Letter Grade</th>
                                                                <th>GPA</th>
                                                                <th>Credits</th>
                                                                <th>Year</th>
                                                                <th>Actions</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody className="grd-table-body">
                                                                {isLoadingStudents ? (
                                                                    <tr>
                                                                        <td colSpan="12" className="grd-loading-state">
                                                                            <div className="grd-loader-wrap">
                                                                                <div className="grd-loader-ring"></div>
                                                                                <span className="grd-loader-text">Loading Students and Subjects</span>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                ) : studentsData.length > 0 ? studentsData.map((student) => (
                                                                <tr
                                                                    key={student.id}
                                                                    onMouseEnter={() => setHoveredStudent(student.id)}
                                                                    onMouseLeave={() => setHoveredStudent(null)}
                                                                    className={hoveredStudent === student.id ? 'grd-row-hovered' : ''}
                                                                >
                                                                    <td>{student.studentName || ''}</td>
                                                                    <td>{student.class || '12'}</td>
                                                                    <td>
                                                                        {renderSubjectDropdown(student.id)}
                                                                    </td>
                                                                   <td>
                                                                        <Form.Control
                                                                            type="number"
                                                                            value={studentInputs[student.id]?.subjectLevel || ''}
                                                                            onChange={(e) => handleInputChange(student.id, 'subjectLevel', e.target.value)}
                                                                            min="0"
                                                                            step="1"
                                                                            onKeyPress={(e) => {
                                                                                if (e.key === '-' || e.key === '.') {
                                                                                    e.preventDefault();
                                                                                }
                                                                            }}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        {renderPaceInputs(student.id, 'paceNumbers')}
                                                                    </td>
                                                                    <td>
                                                                        {renderPaceInputs(student.id, 'paceScores')}
                                                                    </td>
                                                                    <td>
                                                                        <Form.Control
                                                                            type="number"
                                                                            value={studentInputs[student.id]?.percentage || ''}
                                                                            onChange={(e) => handleInputChange(student.id, 'percentage', e.target.value)}
                                                                            readOnly
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <Form.Control
                                                                            type="text"
                                                                            value={studentInputs[student.id]?.letterGrade || ''}
                                                                            onChange={(e) => handleInputChange(student.id, 'letterGrade', e.target.value)}
                                                                            readOnly
                                                                        />
                                                                    </td>
                                                                    <td className="grd-gpa-cell">
                                                                        <Form.Control
                                                                            type="text"
                                                                            value={
                                                                                (String(student.class) !== '10' && String(student.class) !== '12')
                                                                                ? 'N/A'
                                                                                : (studentInputs[student.id]?.gpa ?? '')
                                                                            }
                                                                            readOnly
                                                                            className="text-center"
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <Form.Control
                                                                            type="number"
                                                                            value={studentInputs[student.id]?.credits || ''}
                                                                            onChange={(e) => handleInputChange(student.id, 'credits', e.target.value)}
                                                                            readOnly={!!studentInputs[student.id]?.subjectId}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <Form.Control
                                                                            type="number"
                                                                            value={studentInputs[student.id]?.year || new Date().getFullYear()}
                                                                            onChange={(e) => {
                                                                                const yearValue = parseInt(e.target.value);
                                                                                if (!isNaN(yearValue)) {
                                                                                    handleInputChange(student.id, 'year', yearValue);
                                                                                }
                                                                            }}
                                                                            min="2000"
                                                                            max={new Date().getFullYear() + 5}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                       <button className="grd-btn-save" onClick={() => handleSaveStudentGrades(student.id)}>
                                                                            <CheckCircleFill className="grd-btn-save-icon" /> Save
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                          )) : (
                                                                <tr>
                                                                    <td colSpan="12" className="grd-empty-state">
                                                                        <InfoCircleFill className='grd-empty-icon mx-1'/>No results found
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            <StudentsPagination />
                                        </>
                                    )}
                                </section>
                            </div>
                        </div>
                    </div>
                </div>

                <TranscriptModal 
                    show={showTranscriptModal} 
                    onHide={() => setShowTranscriptModal(false)} 
                    student={transcriptStudent} 
                    gradesData={gradesData}
                />
                
                <GraphModal 
                    show={showGraphModal} 
                    onHide={() => setShowGraphModal(false)} 
                    studentName={activeStudent} 
                    graphData={graphData} 
                />
                
                <GradeSummaryModal 
                    show={gradeSummaryModal.show} 
                    onHide={() => setGradeSummaryModal({...gradeSummaryModal, show: false})} 
                    student={gradeSummaryModal.student} 
                    summaryData={gradeSummaryModal.summaryData} 
                />

               <Modal show={showEditModal} onHide={() => setShowEditModal(false)} className="grd-edit-modal">
                <Modal.Header closeButton className="grd-edit-modal-header">
                    <Modal.Title className="grd-edit-modal-title"><GraphUpArrow /> Edit Grade</Modal.Title>
                </Modal.Header>
                <Modal.Body className="grd-edit-modal-body">
                    <Form>
                    <Form.Group className="grd-edit-modal-field">
                        <Form.Control
                        type="text"
                        value={editData.studentName}
                        readOnly
                        className="grd-edit-modal-input grd-edit-modal-input-readonly"
                        />
                        <Form.Label className="grd-edit-modal-label">Student</Form.Label>
                    </Form.Group>

                    <Form.Group className="grd-edit-modal-field">
                        <Form.Control
                        type="text"
                        value={editData.class}
                        readOnly
                        className="grd-edit-modal-input grd-edit-modal-input-readonly"
                        />
                        <Form.Label className="grd-edit-modal-label">Class</Form.Label>
                    </Form.Group>

                    <Form.Group className="grd-edit-modal-field">
                        <Form.Control
                        type="text"
                        value={editData.subject}
                        readOnly
                        className="grd-edit-modal-input grd-edit-modal-input-readonly"
                        />
                        <Form.Label className="grd-edit-modal-label">Subject</Form.Label>
                    </Form.Group>

                    <Form.Group className="grd-edit-modal-field">
                        <Form.Control
                        type="number"
                        name="subjectLevel"
                        value={editData.subjectLevel || ''}
                        onChange={handleEditChange}
                        min="1"
                        className="grd-edit-modal-input"
                        placeholder=" "
                        />
                        <Form.Label className="grd-edit-modal-label">Subject Level</Form.Label>
                    </Form.Group>

                    <Form.Group className="grd-edit-modal-field">
                        <Form.Control
                        as="textarea"
                        rows={3}
                        name="paceNumbers"
                        value={editData.paceNumbers}
                        onChange={handleEditChange}
                        className="grd-edit-modal-input grd-edit-modal-textarea"
                        placeholder=" "
                        />
                        <Form.Label className="grd-edit-modal-label">Pace Numbers (comma separated)</Form.Label>
                    </Form.Group>

                    <Form.Group className="grd-edit-modal-field">
                        <Form.Control
                        as="textarea"
                        rows={3}
                        name="paceScores"
                        value={editData.paceScores}
                        onChange={handleEditChange}
                        className="grd-edit-modal-input grd-edit-modal-textarea"
                        placeholder=" "
                        />
                        <Form.Label className="grd-edit-modal-label">Pace Scores (comma separated, 0-100)</Form.Label>
                    </Form.Group>

                    <Form.Group className="grd-edit-modal-field">
                        <Form.Control
                        type="number"
                        name="year"
                        value={editData.year || ''}
                        onChange={handleEditChange}
                        min="2000"
                        max="2100"
                        className="grd-edit-modal-input"
                        placeholder=" "
                        />
                        <Form.Label className="grd-edit-modal-label">Year</Form.Label>
                    </Form.Group>

                    <Form.Group className="grd-edit-modal-field">
                        <Form.Control
                        type="text"
                        value={editData.percentage || ''}
                        readOnly
                        className="grd-edit-modal-input grd-edit-modal-input-readonly"
                        />
                        <Form.Label className="grd-edit-modal-label">Percentage</Form.Label>
                    </Form.Group>

                    <Form.Group className="grd-edit-modal-field">
                        <Form.Control
                        type="text"
                        value={editData.letterGrade || ''}
                        readOnly
                        className="grd-edit-modal-input grd-edit-modal-input-readonly"
                        />
                        <Form.Label className="grd-edit-modal-label">Letter Grade</Form.Label>
                    </Form.Group>

                    <Form.Group className="grd-edit-modal-field">
                        <Form.Control
                        type="text"
                        value={
                            (String(editData.class) === '10' || String(editData.class) === '12')
                            ? (editData.gpa !== null
                                ? typeof editData.gpa === 'number'
                                    ? editData.gpa.toFixed(1)
                                    : parseFloat(editData.gpa).toFixed(1)
                                : 'N/A')
                            : 'N/A'
                        }
                        readOnly
                        className="grd-edit-modal-input grd-edit-modal-input-readonly"
                        />
                        <Form.Label className="grd-edit-modal-label">GPA</Form.Label>
                    </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer className="grd-edit-modal-footer">
                    <button className="grd-edit-modal-btn grd-edit-modal-btn-secondary" onClick={() => setShowEditModal(false)}>
                    Cancel
                    </button>
                    <button className="grd-edit-modal-btn grd-edit-modal-btn-primary" onClick={saveEditChanges}>
                    Save Changes
                    </button>
                </Modal.Footer>
                </Modal>

               {/* Delete Modal */}
                <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} className="grd-delete-modal">
                <Modal.Header closeButton className="grd-delete-modal-header">
                    <Modal.Title className="grd-delete-modal-title">Delete Grade</Modal.Title>
                </Modal.Header>
                <Modal.Body className="grd-delete-modal-body">Are you sure you want to delete this grade?</Modal.Body>
                <Modal.Footer className="grd-delete-modal-footer">
                    <button className="grd-delete-modal-btn grd-delete-modal-btn-secondary" onClick={() => setShowDeleteModal(false)}>Cancel</button>
                    <button className="grd-delete-modal-btn grd-delete-modal-btn-danger" onClick={confirmDelete}>Delete</button>
                </Modal.Footer>
                </Modal>
            </div>

            
      {/* Toast */}
            <div className={`grd-toast grd-toast-${toast.variant}${toast.show ? ' grd-toast-show' : ''}`}>
         <div className="grd-toast-header">
        <strong className="grd-toast-title">
            {toast.variant === 'success' ? 'Success' : toast.variant === 'warning' ? 'Warning' : 'Error'}
        </strong>
        <button className="grd-toast-close" onClick={() => setToast(prev => ({ ...prev, show: false }))}>×</button>
    </div>
    <div className="grd-toast-body">
        {toast.variant === 'success'
            ? <CheckCircleFill className="grd-toast-icon" />
            : <ExclamationTriangleFill className="grd-toast-icon" />}
        {toast.message}
    </div>
</div>
     {userRole === 'admin' && (
        <GradesGuideModal/>
            )}
        </>
    );
}

export default Grades;